<template>
  <table class="table text-center">
    <tbody>
      <tr v-for="block in activeBlocks" :key="block.id">
        <th scope="row">
          <el-tag type="info">
            {{ $t('common_words.name') }} {{ block.name }}
          </el-tag>
        </th>
        <td class="text-left">
          <span v-for="lot in block.lots" :key="lot.id || lot.name">
            <el-tag type="info" style="height: auto; min-width: 230px">
              <template v-if="lot.code">
                {{ $t('common_words.code') }}: {{ lot.code }} <br />
              </template>
              {{ $t('common_words.name') }} : {{ lot.name }} <br />
              {{ $t('common_words.area') }}: {{ lot.area }} <br />
              {{ $t('common_words.variety') }} :
              {{
                lot.cropVariety
                  ? lot.cropVariety.name
                  : $t('common_words.no_assignment')
              }}
              <br />
              {{ $t('common_words.soil_type') }}:
              <span style="text-transform: capitalize">
                {{
                  lot.soil_type_id
                    ? lot.soil_type.name
                    : $t('common_words.none')
                }}
              </span>
              <br />
              {{ $t('common_words.population') }}:
              {{ lot.population ? lot.population : $t('common_words.none') }}
            </el-tag>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'lots-info-dialog',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // Mostrar solo bloques activos
    activeBlocks() {
      const blocks = this.rowData.blocks || [];
      return blocks.filter((b) => !b.deleted_at);
    },
  },
};
</script>
